import { injectable } from 'inversify';
import { useAppSelector } from '../../state/hooks';
import { ConneqtRepository } from '../../state/reduxRepositories';
import {
  Conneqt,
  ConneqtStatus,
} from '../../state/reduxRepositories/conneqt/conneqt.interfaces';

@injectable()
export class ConneqtPlayerDomain {
  constructor(private conneqtRepository: ConneqtRepository) {}

  useConneqtExistSelector = () => {
    // QUESTION: why is every used here?
    return useAppSelector(
      this.conneqtRepository.selectors.resourcesSelector,
    ).every((arr) => arr.length === 0);
  };

  dispatchInviteSentStatus = (id: string) => {
    this.conneqtRepository.dispatchUpdate({
      id,
      status: ConneqtStatus.INVITE_SENT,
    });
  };

  hasBeenConneqted(conneqt: Conneqt) {
    return (
      conneqt.status === ConneqtStatus.Conneqted ||
      conneqt.status === ConneqtStatus.Disconneqted
    );
  }
}
